module.exports = __webpack_public_path__ + "static/media/logo-kiuono-white.9adf6474.svg";